import { render, staticRenderFns } from "./tracking_inquiry_info.vue?vue&type=template&id=1a9270b5&"
import script from "./tracking_inquiry_info.vue?vue&type=script&lang=js&"
export * from "./tracking_inquiry_info.vue?vue&type=script&lang=js&"
import style0 from "./tracking_inquiry_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports